import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

/**
 * The MapboxDraw theme extended to include styles specific to planner projects
 * when drawing address features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  if (style.id === "gl-draw-point-stroke-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-radius": 10,
        "circle-color": "#FFF000",
      },
    } as mapboxgl.CircleLayer;
  }

  // Convert the default point styles to symbols rather than circles
  if (["gl-draw-point-active", "gl-draw-point-inactive"].includes(style.id)) {
    return {
      ...style,
      type: "symbol",
      layout: {
        "text-field": "\uE8C8",
        "text-anchor": "bottom",
        "text-justify": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true,
        "text-font": ["fontello Regular"],
        "text-offset": [0.05, 0],
        "text-padding": 0,
        "text-rotate": 0.01,
        "text-size": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 12],
        "text-line-height": -0.45,
      },
      paint: {
        "text-opacity": 1,
        "text-translate": [-0.6, 0.1],
        "text-halo-width": 1,
        "text-halo-color": "#ffffff",
      },
    } as mapboxgl.SymbolLayer;
  }

  return style;
});

const styles: MapboxStyleLayer[] = [
  ...modifiedDefaults,
  // Add a custom hover style
  {
    id: "gl-draw-point-hover-active",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    paint: {
      "circle-color": "#BBD5ED",
      "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 5],
      "circle-opacity": ["case", ["==", ["get", "user_meta:hover"], "true"], 1, 0],
      "circle-stroke-width": ["case", ["==", ["get", "user_meta:hover"], "true"], 2, 0],
      "circle-stroke-color": "#8BA2B7",
    },
  },
];

export default styles;
